// Module
var code = `<div ng-transclude class="gf-form-query-content"></div>

`;
// Exports
var _module_exports =code;;
var path = 'public/app/angular/panel/partials/query_editor_row.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;